import { commaizeNumber } from '@/utils/primitive/number'
import { GoodsDetailResponse } from '~/api/types/goods'

export const useBenefit = () => {
  const goodsCoupon = (goods: GoodsDetailResponse) => {
    const returnData = []

    if (goods?.promotionInfo?.cpBnftList) {
      for (let i = 0; i < goods?.promotionInfo?.cpBnftList.length; i++) {
        const items = goods?.promotionInfo?.cpBnftList[i]
        let cpName = ''
        let salePrice

        if (items.cpType === '10') {
          if (items.cpApplySpr === '1') {
            cpName = commaizeNumber(`${items.bnftVal}원`)
            salePrice = commaizeNumber(`${items.bnftVal}`)
          } else {
            cpName = commaizeNumber(`${items.bnftVal}%`)
            salePrice = (Number(items.cpBeforePrice) * items.bnftVal) / 100

            if (Number(items.maxBnftLimit) < Number(salePrice) && Number(items.maxBnftLimit) > 0) {
              salePrice = commaizeNumber(items.maxBnftLimit)
            } else {
              salePrice = commaizeNumber(Math.ceil(salePrice / 10) * 10)
            }
          }
        }

        if (cpName && salePrice) {
          returnData.push(cpName, salePrice)
        }
      }
    }
    return returnData
  }

  const marketingCoupon = (goods: GoodsDetailResponse) => {
    const returnData = []

    if (goods?.promotionInfo?.cpBnftList) {
      for (let i = 0; i < goods?.promotionInfo?.cpBnftList.length; i++) {
        const items = goods?.promotionInfo?.cpBnftList[i]
        let cpName = ''
        let salePrice

        if (items.cpType === '30') {
          if (items.cpApplySpr === '1') {
            cpName = commaizeNumber(`${items.bnftVal}원`)
            salePrice = commaizeNumber(`${items.bnftVal}`)
          } else {
            cpName = commaizeNumber(`${items.bnftVal}%`)
            salePrice = (Number(items.cpBeforePrice) * items.bnftVal) / 100
            salePrice = Math.ceil(salePrice / 10) * 10

            if (Number(items.maxBnftLimit)) {
              cpName += `/ 최대 ${commaizeNumber(items.maxBnftLimit)}원`

              if (Number(items.maxBnftLimit) < Number(salePrice)) {
                salePrice = Number(items.maxBnftLimit)
              }
            }
            salePrice = commaizeNumber(salePrice)
          }
        }

        if (cpName && salePrice) {
          returnData.push(cpName, salePrice)
        }
      }
    }
    return returnData
  }

  return {
    goodsCoupon,
    marketingCoupon
  }
}
